import { Helmet } from "react-helmet";

export const SEOHead = () => {
  const title = "Sky Lofi ATC - Lofi Hip Hop Beats with Live Air Traffic Control Radio";
  const description = "Stream free lofi hip hop music mixed with real-time ATC radio from airports worldwide. Perfect for studying, coding, and deep focus. 24/7 ad-free lofi beats with authentic air traffic control communications.";
  const url = "https://skylofiatc.lovable.app/";
  const image = "https://skylofiatc.lovable.app/og-image.jpg"; // You'll want to create this

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content="lofi, lofi hip hop, lofi beats, ATC radio, air traffic control, study music, focus music, chill beats, ambient music, lofi ATC, study beats, concentration music, coding music, work music, relaxation music, free lofi stream, 24/7 lofi, aviation radio, airport radio" />
      <link rel="canonical" href={url} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="Sky Lofi ATC" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* Additional SEO */}
      <meta name="robots" content="index, follow" />
      <meta name="language" content="English" />
      <meta name="author" content="Sky Lofi ATC" />
      <meta name="theme-color" content="#1a1f2e" />
    </Helmet>
  );
};
